module.exports = __webpack_public_path__ + "img/pic_mirror@2x.82f0cd5b.png";